(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luna-brand-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luna-brand-reveal')) {
    customElements.define('luna-brand-reveal', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) this.classList.toggle('is-visible', entry.isIntersecting);
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luna-in-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luna-motion-controller')) {
    class LunaMotionController extends HTMLElement {
      connectedCallback() {
        this.addEventListener('play', (event) => {
          if (event.target.tagName !== 'VIDEO') return;
          this.querySelectorAll('video').forEach((video) => {
            if (video !== event.target) video.pause();
          });
        }, true);
      }
    }
    customElements.define('luna-motion-controller', LunaMotionController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
